module Environments {
    module.controller("NewAgentController", [
        "$scope",
        "$stateParams",
        "AgentsService",
        function ($scope, $stateParams, agentsService: IAgentService) {
            $scope.agent = {};

            let isGateway = $stateParams.isGateway
            agentsService.getNewAgent($scope.environment, $scope.agentGroup, isGateway).then(function (response) {
                if (response) {
                    $scope.agent = response.data;
                } else {
                    //location:'replace' will replace the current state (environments.detail.agent.new) with the target state (environments.detail) in the history.
                    //this is so that hitting the back button will not try to go to the newAgent page again, blocking access to the rest of the history stack.
                    var environmentName = $scope.environment.name || "Default";
                    var agentGroupName = $scope.agentGroup.name;
                    $scope.$state.go("environments.detail", { environmentName: environmentName, agentGroupName: agentGroupName }, { location: "replace" });
                }
            });
        }
    ]);
}